var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#F1F6FC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 8.65125C11.4308 8.65125 11 8.29458 11 7.83223C11 7.36988 11.4308 7 12 7C12.5692 7 13 7.35667 13 7.80581C13 8.28137 12.5846 8.65125 12 8.65125ZM11.2615 17V9.99868H12.7385V17H11.2615Z",
    fill: "#586370"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info-icon.341a83bcb6fb54fb0349b785ab415403.svg";
export { ForwardRef as ReactComponent };